import { createPersistedToggle } from "./persisted-toggle";

export const useProductImageVisibility = createPersistedToggle("twelve-volt:show-product-images", true);
